import React, { useState } from 'react';
import { Dispatch } from '../../clients/quipli-service/order/order';
import { Modal } from '../../components/modal/modal';
import { TransitionDispatchForm } from '../dispatch/components/transition-dispatch-form';
import {
  DispatchDirection,
  DispatchProgress,
  ItemDispatchProgress,
} from '../../clients/quipli-service/dispatch/dispatch';
import { toast } from '../../util/toasts';
import { Button } from '../../components/form/button';

const TransitionDispatchModal = ({
  onClose,
  onComplete,
  dispatch,
  direction,
}: {
  onClose: () => void;
  onComplete: () => void;
  dispatch: Dispatch;
  direction: DispatchDirection;
}) => {
  return (
    <Modal
      isOpen={true}
      title={`Complete ${direction == DispatchDirection.DELIVERY ? 'Delivery' : 'Pickup'}`}
      close={onClose}
    >
      <TransitionDispatchForm
        direction={direction}
        orderId={dispatch.orderId}
        update={async () => {
          onComplete();
        }}
      />
    </Modal>
  );
};
export const DispatchStatusTransitionButton = ({
  orderDispatch,
  reload,
  direction,
}: {
  orderDispatch: Dispatch;
  reload: () => void;
  direction?: DispatchDirection;
}) => {
  const [isTransitionModalOpen, setIsTransitionModalOpen] = useState<DispatchDirection | undefined>();

  return orderDispatch && orderDispatch.status != DispatchProgress.COMPLETE ? (
    <div className="flex flex-row gap-2">
      {orderDispatch.products.delivery?.filter((_) => _.deliveryStatus !== ItemDispatchProgress.COMPLETE).length &&
      (!direction || direction == DispatchDirection.DELIVERY) ? (
        <Button className="button button-yellow" onClick={() => setIsTransitionModalOpen(DispatchDirection.DELIVERY)}>
          Complete Delivery
        </Button>
      ) : (
        <></>
      )}
      {orderDispatch.products.pickup?.filter(
        (_) =>
          _.pickupStatus &&
          _.pickupStatus != ItemDispatchProgress.COMPLETE &&
          (_.deliveryStatus == ItemDispatchProgress.COMPLETE || !_.deliveryStatus),
      ).length &&
      (!direction || direction == DispatchDirection.PICKUP) ? (
        <Button className="button button-yellow" onClick={() => setIsTransitionModalOpen(DispatchDirection.PICKUP)}>
          Complete Pickup
        </Button>
      ) : (
        <></>
      )}
      {isTransitionModalOpen && orderDispatch && (
        <TransitionDispatchModal
          dispatch={orderDispatch}
          onClose={() => setIsTransitionModalOpen(undefined)}
          direction={isTransitionModalOpen}
          onComplete={() => {
            reload();
            toast('Dispatches updated');
            setIsTransitionModalOpen(undefined);
          }}
        />
      )}
    </div>
  ) : (
    <></>
  );
};
